<template>
  <div class="mt-10">
    <div class="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
      <div class="md:grid md:grid-cols-3 md:gap-6">
        <div class="md:col-span-1">
          <h3 class="text-lg font-medium leading-6 text-gray-900">
            Office Hours
          </h3>
          <p class="mt-1 text-sm leading-5 text-gray-500">
            Set office hours for your agents. If the customer visits your
            website outside of your office hours we wont show the contact
            button.
          </p>
        </div>
        <div class="md:col-span-2">
          <Alert
            v-if="config.officeHours.isEnabled"
            :type="'warning'"
            :text="alertText"
          />
          <fieldset class="mt-6">
            <legend class="text-base leading-6 font-medium text-gray-900">
              Enable office hours
            </legend>

            <div class="mt-4 flex flex-wrap">
              <VSwitch v-model="config.officeHours.isEnabled" />
            </div>
          </fieldset>

          <div v-if="config.officeHours.isEnabled" class="mt-4">
            <fieldset class="mt-6 mb-4">
              <legend class="text-base leading-6 font-medium text-gray-900">
                Time zone
              </legend>

              <div class="mt-4 flex flex-wrap">
                <select
                  v-model="config.officeHours.timezone"
                  class="mt-1 block  py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  style="color: #22292f;"
                >
                  <option
                    v-for="(option, index) in timezoneOptions"
                    :key="index"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>
            </fieldset>
            <label class="">Hours</label>
            <table class="w-full">
              <tbody>
                <tr v-for="(officeHour, index) in officeHours" :key="index">
                  <td class="text-gray-700 text-sm" data-qa="selected_day">
                    {{ dayTitle[index + 1] }}
                  </td>
                  <td class="flex items-center">
                    <select
                      v-model="officeHour.officeHoursOpen"
                      class="mt-1 block  py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      style="color: #22292f;"
                    >
                      <option
                        v-for="(option, index) in timeOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.text }}
                      </option>
                    </select>

                    <div class="w-6  border border-gray-200 mx-2" />
                    <select
                      v-model="officeHour.officeHoursClosed"
                      class="mt-1 block  py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      style="color: #22292f;"
                    >
                      <option
                        v-for="(option, index) in timeOptions"
                        :key="index"
                        :value="option.value"
                      >
                        {{ option.text }}
                      </option>
                    </select>
                    <label class="text-gray-500 ml-4 text-sm">
                      <input
                        type="checkbox"
                        v-model="officeHour.officeClosed"
                      />
                      Office Closed
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  class="Polaris-Button Polaris-Button--primary"
                  type="submit"
                  @click="updateOfficeHours"
                >
                  <span class="Polaris-Button__Content">
                    <span class="Polaris-Button__Text">Save</span>
                  </span>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VSwitch from "../../components/Common/VSwitch";
import Timezone from "../../Mixins/timezones";
import Alert from "../../components/Common/Alert";

export default {
  name: "OfficeHours",
  mixins: [Timezone],
  components: {
    VSwitch,
    Alert
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    if (
      this.config.officeHours.officeHours &&
      this.config.officeHours.officeHours.length > 0
    ) {
      this.officeHours = this.config.officeHours.officeHours;
    }
  },
  data() {
    return {
      alertText:
        "If office hours are enabled in the chat. We won't show the button if the time lies away from office hours. If you would like to always show up, please disable office hours.",
      timezoneOptions: this.getTimezoneOptions(),
      dayTitle: {
        1: "Monday",
        2: "Tuesday",
        3: "Wednesday",
        4: "Thursday",
        5: "Friday",
        6: "Saturday",
        7: "Sunday"
      },
      officeHours: [
        {
          officeHoursOpen: 9,
          officeHoursClosed: 17,
          officeClosed: false
        },
        {
          officeHoursOpen: 9,
          officeHoursClosed: 17,
          officeClosed: false
        },
        {
          officeHoursOpen: 9,
          officeHoursClosed: 17,
          officeClosed: false
        },
        {
          officeHoursOpen: 9,
          officeHoursClosed: 17,
          officeClosed: false
        },
        {
          officeHoursOpen: 9,
          officeHoursClosed: 17,
          officeClosed: false
        },
        {
          officeHoursOpen: 9,
          officeHoursClosed: 17,
          officeClosed: true
        },
        {
          officeHoursOpen: 9,
          officeHoursClosed: 17,
          officeClosed: true
        }
      ],
      timeOptions: [
        { text: "12 am", value: 0 },
        { text: "1 am", value: 1 },
        { text: "2 am", value: 2 },
        { text: "3 am", value: 3 },
        { text: "4 am", value: 4 },
        { text: "5 am", value: 5 },
        { text: "6 am", value: 6 },
        { text: "7 am", value: 7 },
        { text: "8 am", value: 8 },
        { text: "9 am", value: 9 },
        { text: "10 am", value: 10 },
        { text: "11 am", value: 11 },
        { text: "12 pm", value: 12 },
        { text: "1 pm", value: 13 },
        { text: "2 pm", value: 14 },
        { text: "3 pm", value: 15 },
        { text: "4 pm", value: 16 },
        { text: "5 pm", value: 17 },
        { text: "6 pm", value: 18 },
        { text: "7 pm", value: 19 },
        { text: "8 pm", value: 20 },
        { text: "9 pm", value: 21 },
        { text: "10 pm", value: 22 },
        { text: "11 pm", value: 23 }
      ]
    };
  },
  methods: {
    updateOfficeHours() {
      this.config.officeHours.officeHours = this.officeHours;
      this.$emit("save");
    }
  }
};
</script>

<style lang="scss" scoped></style>
